
<p style="display:none">{{title}}</p>
<div class="row" *ngIf="typeServiceForm">
  <form role="form" [formGroup]="typeServiceForm">

    <div class="col-sm-12 col-md-12">
      <div class="entradas-de-texto-govco">
        <label for="servicesToProvide" class="form-label">Servicios<span class="required">*</span></label>
        <div class="container-input-texto-govco">
          <textarea formControlName="servicesToProvide"
                    [ngClass]="{'error': isTouchedField(typeServiceForm, 'servicesToProvide')}"
                    name="" id="servicesToProvide"
                    class="form-control"
                    aria-invalid="true"
                    aria-describedby="servicesToProvide-note"
                    rows="3"
          ></textarea>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="servicesToProvide-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('servicesToProvide') }}
          </span>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-12">
      <div class="entradas-de-texto-govco">
        <label for="basicCharacteristicsServices" class="form-label">Características básicas del servicio<span class="required">*</span></label>
        <div class="container-input-texto-govco">
          <textarea formControlName="basicCharacteristicsServices"
                    [ngClass]="{'error': isTouchedField(typeServiceForm, 'basicCharacteristicsServices')}"
                    name="" id="basicCharacteristicsServices"
                    class="form-control"
                    aria-invalid="true"
                    aria-describedby="basicCharacteristicsServices-note"
                    rows="3"
          ></textarea>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="basicCharacteristicsServices-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('basicCharacteristicsServices') }}
          </span>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-12">
      <div class="entradas-de-texto-govco">
        <label for="otherServices" class="form-label">¿Otros Cuáles? </label>
        <div class="container-input-texto-govco">
          <textarea formControlName="otherServices"
                    class="form-control"
                    rows="3"
                    id="otherServices"
                    aria-describedby="otherServices-note"
          ></textarea>
        </div>
      </div>
    </div>

  </form>
</div>
